var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('el-pagination',{attrs:{"current-page":_vm.currentPage4,"page-sizes":[100, 200, 300, 400],"page-size":100,"layout":"total, sizes, prev, pager, next, jumper","total":400},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }